import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-primary-950">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight">茄子视频</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              茄子视频是一个专注于优质短视频分享与在线播放的内容平台。我们把娱乐、生活、搞笑、音乐、美食与旅行的精彩片段整理好，让你用最短的时间，看到最值得看的内容。
            </p>
            <p className="mt-6 font-label text-[11px] uppercase tracking-[0.2em] text-primary-300">
              Share the moment · Watch the world
            </p>
          </div>

          <div className="md:col-span-2">
            <h2 className="font-label text-xs uppercase tracking-[0.16em] text-primary-300">探索</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-background-100/85 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/favorites"
                  className="text-background-100/85 transition-colors hover:text-accent-300"
                >
                  我的收藏
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-background-100/85 transition-colors hover:text-accent-300"
                >
                  搜索视频
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-100/85 transition-colors hover:text-accent-300"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h2 className="font-label text-xs uppercase tracking-[0.16em] text-primary-300">热门分类</h2>
            <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-background-100/85 transition-colors hover:text-accent-300"
                  >
                    {category.name}视频
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h2 className="font-label text-xs uppercase tracking-[0.16em] text-primary-300">联系</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2 text-background-100/85">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400"></i>
                <span className="break-all">feedback@eggplant.tv</span>
              </li>
              <li className="flex items-start gap-2 text-background-100/85">
                <i className="ri-time-line mt-0.5 text-base text-accent-400"></i>
                <span>每日 09:00 - 22:00 更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800/70 pt-6 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 茄子视频 · 本站视频与内容均为虚构演示数据，仅用于界面展示。</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/about" className="transition-colors hover:text-accent-300">
              使用说明
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-300">
              隐私声明
            </Link>
            <span className="font-label tracking-wider">MADE FOR SHORT VIDEO LOVERS</span>
          </div>
        </div>
      </div>
    </footer>
  );
}